import { Pane, Avatar } from 'evergreen-ui';
import { memo, useState } from 'react';

import logo from '../assets/Catalight-Care-Services.webp';
import {oktaAppByUrl, WORDPRESS_HOME_URL} from './util';
import {useCurrentUser} from '../../security';
import {useOktaAuth} from '@okta/okta-react';
import { ApplicationRootUrl, useApplicationIsInternalAuth, useApplicationRoot } from 'common/component/ApplicationRootContext';
import { useHistory } from 'react-router-dom';
import { clearProviderViewAsSession } from 'providerapp/core/persistence/provider-view-as-state-magement';

type HeaderProps = {
    changeProvider?: () => void;
}


export const Header = memo(({changeProvider}: HeaderProps) => {
    const currentUser = useCurrentUser();
    const oktaAuthContext = useOktaAuth();
    const isInternalAuth = useApplicationIsInternalAuth();
    const history = useHistory();
    const applicationRoot = useApplicationRoot();
    const [isLoggingViewAsOut, setIsLoggingViewAsOut] = useState(false);

    const logoutViewAs = async () => {
        setIsLoggingViewAsOut(true);
        clearProviderViewAsSession();
        switch (applicationRoot) {
            case ApplicationRootUrl.AZURE_INTERNAL_UM_PROVIDER_ROUTE_NAME:
                history.push(`/${ApplicationRootUrl.AZURE_INTERNAL_UM_ROUTE_NAME}`);
                break;
            default:
                history.push(`/${ApplicationRootUrl.AZURE_INTERNAL_CP_ROUTE_NAME}`);
        }
    }

    
    const handleLogout = async () => {
        if (oktaAuthContext) {
            await oktaAuthContext.oktaAuth.tokenManager.clear();
            await oktaAuthContext.oktaAuth.signOut({
                revokeAccessToken: true,
                revokeRefreshToken: true,
                postLogoutRedirectUri: oktaAppByUrl(window.location.href) === 'UM' ? '/eum' : '/provider/clients'
            });
        } else {
            if (changeProvider) {
                changeProvider();
            }
        }
    };
    
    return (
        <Pane 
            className="portal-layout-header w-full flex items-center justify-between" 
            // Azure auth background color is different, the background of azure should be verify different than the normal
            // to make user know which auth is using
            backgroundColor={isInternalAuth ? '#689F38' : '#435b73'}
            height={84}
            minHeight={84}
        >
            <a
                className='portal-header-logo'
                href={WORDPRESS_HOME_URL}
            >
                <img 
                    src={logo} 
                    alt="Catalight Care Services" 
                />
            </a>
            
            <div className="flex items-center gap-3 px-3 py-2">
                <Avatar
                    name={currentUser?.email?.split('@')[0] || 'User'}
                    size={40}
                    hashValue={currentUser?.email}
                />
                <div className="flex flex-col">
                    <div className="text-sm font-medium text-white">{currentUser?.email}</div>
                    <div className="text-xs text-gray-200">{isInternalAuth ? 'Provider: ' : ''}{currentUser?.provider?.name}</div>
                    <div className="flex justify-between" >
                        <div 
                            className="text-xs font-semibold text-red-400 hover:text-red-300 cursor-pointer transition-colors mt-1"
                            onClick={handleLogout}
                        >
                            {isInternalAuth ? 'Change Provider' : 'Logout'}
                        </div>
                        {
                            isInternalAuth && (
                                <div 
                                    className={`pl-2 font-semibold text-xs text-red-400 hover:text-red-300 cursor-pointer transition-colors mt-1 ${isLoggingViewAsOut ? 'opacity-50 cursor-not-allowed' : ''}`}
                                    onClick={() => !isLoggingViewAsOut && logoutViewAs()}
                                >
                                    {isLoggingViewAsOut ? 'Logging out...' : 'Logout'}
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </Pane>
    );
});
